import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    CompleteConnectionBodySchema,
    ConnectionResponseSchema,
    ConnectionReuseResponseSchema,
    CreateConnectionBodySchema,
    CreateScheduleBodySchema,
    PickerCredentialsResponseSchema,
    RefreshNowResponseSchema,
    ReportAccessResponseSchema,
    SchedulePathParamsSchema,
    SpreadsheetAccessResponseSchema,
    SpreadsheetPathParamsSchema,
    ScheduleResponseSchema,
    StartConnectionResponseSchema,
} from "../schemas/domains/googleSheets/google-sheets-addon.schema";

const c = initContract();

export const googleSheetsAddonContract = c.router(
    {
        getConnection: {
            method: "GET",
            path: "/connection",
            responses: {
                200: ConnectionResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        createConnection: {
            method: "POST",
            path: "/connection",
            body: CreateConnectionBodySchema,
            responses: {
                200: ConnectionResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                502: ErrorMessageSchema,
            },
        },
        startConnection: {
            method: "POST",
            path: "/connection/start",
            body: c.noBody(),
            responses: {
                200: StartConnectionResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        completeConnection: {
            method: "POST",
            path: "/connection/complete",
            body: CompleteConnectionBodySchema,
            responses: {
                200: ConnectionResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                502: ErrorMessageSchema,
            },
        },
        reuseConnection: {
            method: "POST",
            path: "/connection/reuse",
            body: c.noBody(),
            responses: {
                200: ConnectionReuseResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        getReportAccess: {
            method: "GET",
            path: "/report-access",
            responses: {
                200: ReportAccessResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        getPickerCredentials: {
            method: "GET",
            path: "/picker-credentials",
            responses: {
                200: PickerCredentialsResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                422: ErrorMessageSchema,
            },
        },
        getSpreadsheetSchedule: {
            method: "GET",
            path: "/spreadsheets/:spreadsheetId/schedule",
            pathParams: SpreadsheetPathParamsSchema,
            responses: {
                200: ScheduleResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: c.noBody(),
            },
        },
        getSpreadsheetAccess: {
            method: "GET",
            path: "/spreadsheets/:spreadsheetId/access",
            pathParams: SpreadsheetPathParamsSchema,
            responses: {
                200: SpreadsheetAccessResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        createSchedule: {
            method: "POST",
            path: "/schedules",
            body: CreateScheduleBodySchema,
            responses: {
                201: ScheduleResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                422: ErrorMessageSchema,
            },
        },
        deleteSchedule: {
            method: "DELETE",
            path: "/schedules/:id",
            pathParams: SchedulePathParamsSchema,
            body: c.noBody(),
            responses: {
                204: c.noBody(),
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        refreshNow: {
            method: "POST",
            path: "/schedules/:id/refresh-now",
            pathParams: SchedulePathParamsSchema,
            body: c.noBody(),
            responses: {
                202: RefreshNowResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                429: ErrorMessageSchema,
            },
        },
        disconnect: {
            method: "POST",
            path: "/disconnect",
            body: c.noBody(),
            responses: {
                204: c.noBody(),
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    { pathPrefix: "/google-sheets/addon" },
);
